import loadable from "@loadable/component";

export default loadable(() => import(/* webpackChunkName: 'cameracapture' */ "../CameraCapture"), {
    fallback: null,
});
